import { React, useState ,useEffect} from "react";

export default function Affiliate() {
  const initialValues = {
    name: "",
    phoneNo: "",
    query: "",
  };

  const [formValues, setformValues] = useState(initialValues);
  const [formError, setformError] = useState({});
  const [isSubmit, setisSubmit] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setformValues({ ...formValues, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setformError(validate(formValues));
    setisSubmit(true);
  };

  const validate = (values) => {
    const errors = {};
    if (!values.phoneNo) {
      errors.phoneNo = "Phone No. is Required";
    }

    if (!values.name) {
      errors.name = "Name is Required";
    }
    if (!values.phoneNo) {
      errors.phoneNo = "Phone No is Required";
    }
    if (!values.query) {
      errors.query = "Query is Required";
    }

    return errors;
  };

  const style = {
    color: "red",
    fontSize: "14px",
  };

  useEffect(() => {
    if (Object.keys(formError).length === 0 && isSubmit) {
            window.location=`https://api.whatsapp.com/send?phone=+919820043813&text=
            +Name : ${formValues.name} +%0a
            +Phone No : ${formValues.phoneNo} +%0a
            +Query : ${formValues.query}`
    }
  },[formError]);

  return (
    <>
          <div style={{ height: "108px" }}></div>

    <div className="container py-4 my-4" style={{ height: "100vh" }}>
      <h2 style={{marginBottom:"20px"}}>Ask Your Query</h2>
      <form onSubmit={handleSubmit}>
        <div class="mb-3">
          <label for="exampleInputEmail1" class="form-label">
            Name
          </label>
          <input
            type="text"
            class="form-control"
            id="exampleInputEmail1"
            aria-describedby="emailHelp"
            name="name"
            value={formValues.name}
            onChange={handleChange}
          />
        </div>
        <p style={style}>{formError.name}</p>
        <div class="mb-3">
          <label for="exampleInputPassword1" class="form-label">
            Phone Number
          </label>
          <input
            type="number"
            class="form-control"
            id="exampleInputPassword1"
            name="phoneNo"
            value={formValues.phoneNo}
            onChange={handleChange}
          />
        </div>
        <p style={style}>{formError.phoneNo}</p>

        <div class="mb-3">
          <label for="exampleFormControlTextarea1" class="form-label">
            Comment
          </label>
          <textarea
            class="form-control"
            id="exampleFormControlTextarea1"
            rows="3"
            name="query"
            value={formValues.query}
            onChange={handleChange}
          ></textarea>
        </div>
        <p style={style}>{formError.query}</p>
        

        <button
          type="submit"
          class="btn"
          style={{ backgroundColor: "#032044", color: "white" }}
          onClick={handleSubmit}
          >
          Send to Whatsapp
        </button>
      </form>
    </div>
    </>

  );
}
